import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@hub-la/design-system';
import { useFormikContext } from 'formik';
import '../../../domain/dtos/asset-status.js';
import '../../../domain/dtos/asset-subtype.js';
import '../../../domain/dtos/asset-type.js';
import { MAX_FILE_SIZE } from '../../../domain/dtos/max-file-size.js';
import '../../../domain/dtos/query-key.js';
import { UploadStatus } from '../../../domain/dtos/upload-status.js';
import 'core-js/modules/es.promise.js';
import '../../../usecases/delete-asset.js';
import 'core-js/modules/es.parse-float.js';
import 'core-js/modules/es.number.to-fixed.js';
import 'uuid';
import '../../../usecases/get-asset.js';
import '../../../usecases/get-assets-signed-url.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import 'react-pdf';
import { getValidFileExtensions } from '../../../usecases/get-valid-file-extensions.js';
import '../../../usecases/get-video-thumbnail.js';
import '../../../envs.js';
import '../../../usecases/save-asset.js';
import '../../../usecases/save-asset-progress.js';
import '../../../usecases/update-asset.js';
import '@hub-la/fe-container';
import '@hub-la/fe-core-http-client';
import 'react-query';
import { useUploadAsset } from '../../hooks/use-upload-asset.js';

let _ = t => t,
  _t;
const Label = styled('label')(_t || (_t = _`
  cursor: pointer;
`));
const AssetUploader = ({
  field,
  children,
  disabled,
  statusFieldName
}) => {
  const {
    setFieldValue
  } = useFormikContext();
  const {
    mutateAsync
  } = useUploadAsset();
  const validExtensions = getValidFileExtensions(field);
  const handleUpload = file => {
    if (validExtensions && !validExtensions.split(',').includes(file.type)) {
      setFieldValue(statusFieldName, UploadStatus.FILE_NOT_ALLOWED);
      return;
    }
    mutateAsync({
      file,
      field
    });
  };
  return jsxs(Label, Object.assign({
    htmlFor: field
  }, {
    children: [jsx("input", {
      type: "file",
      "data-max-size": MAX_FILE_SIZE,
      id: field,
      name: field,
      "data-testid": field,
      accept: validExtensions,
      style: {
        display: 'none',
        margin: 0,
        padding: 0
      },
      disabled: Boolean(disabled),
      onChange: e => {
        handleUpload(e.target.files[0]);
        e.target.value = '';
      }
    }), children]
  }));
};

export { AssetUploader };
